import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import img1 from "../../../../src/pages/toolkit/develop/dynamic-updates/images/overlap.png";
import img2 from "../../../../src/pages/toolkit/develop/dynamic-updates/images/tooltip.png";
import img3 from "../../../../src/pages/toolkit/develop/dynamic-updates/images/tooltip1.png";
import img4 from "../../../../src/pages/toolkit/develop/dynamic-updates/images/tooltip3.png";
import img14 from "../../../../src/visuals/develop/coding_interactions_dynamic_11_do.png";
import img15 from "../../../../src/visuals/develop/coding_interactions_dynamic_11_dont.png";
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import * as React from 'react';
export default {
  Row,
  Column,
  img1,
  img2,
  img3,
  img4,
  img14,
  img15,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  React
};